import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { TZDate } from '@date-fns/tz';

/**
 * Pure pipe that formats a date value using a date-fns format string and an
 * optional IANA timezone name.
 *
 * Usage: `{{ date | appDate: dateFormat() : dateTimezone() }}`
 *
 * When `timezone` is empty/undefined the pipe uses the browser's local time.
 */
@Pipe({
  name: 'appDate',
  standalone: true,
  pure: true,
})
export class AppDatePipe implements PipeTransform {
  transform(
    value: Date | string | number | null | undefined,
    formatStr: string,
    timezone?: string,
  ): string | null {
    if (value == null) return null;

    try {
      const date = value instanceof Date ? value : new Date(value as string | number);
      if (isNaN(date.getTime())) return null;

      const tz = timezone === '' ? undefined : timezone;
      return format(tz ? new TZDate(date, tz) : date, formatStr);
    } catch {
      return null;
    }
  }
}
